<template>
  <div class="app-chart">
    <div class="pick-summary">
      <div class="pick-box">
        <ConfigForms
          label-width="40px"
          :inline="false"
          :formItems="formItems"
          :data="params"
          @change="updateParams"
        ></ConfigForms>
        <div class="pick-btns">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="refresh"
            >查询</el-button
          >
          <el-button size="small" type="success" icon="el-icon-refresh"
            >刷新</el-button
          >
        </div>
      </div>
      <div class="summary-box">
        <div
          class="summary-item"
          :class="{ even: i % 2, 'last-line': (i + 1) / 4 > 3 }"
          v-for="(grid, i) in grids"
          :key="i"
        >
          <span>{{ grid.label }}</span>
          <span class="val">{{ grid.value | formatNumber }}</span>
        </div>
      </div>
    </div>

    <Chart
      style="height: 350px"
      :options="options"
      :chartData="chartDataProfit"
    ></Chart>
    <Chart
      style="height: 350px"
      :options="options"
      :chartData="chartDataAmount"
    ></Chart>
    <Chart
      style="height: 350px"
      :options="options"
      :chartData="chartDataUSDT"
    ></Chart>
    <Chart
      style="height: 350px"
      :options="options"
      :chartData="chartDataMessage"
    ></Chart>
    <Chart
      style="height: 350px"
      :options="options"
      :chartData="chartDataUser"
    ></Chart>
  </div>
</template>

<script>
import ConfigForms from "@/components/config-forms";
import { appOptions } from "../../config";
import aiFriendManageApi from "../../../api/aiFriendManage";
import Chart from "../components/chart.vue";
import { isInteger } from "lodash";
import moment from "moment";

const chartLineColors = [
  "rgba(243,15,15,1)",
  "rgba(68,190,190,1)",
  "rgba(204,120,17,1)",
];
const lastChartLineColors = [
  "rgba(243,15,15,0.4)",
  "rgba(68,190,190,0.4)",
  "rgba(204,120,17,0.4)",
];

export default {
  name: "AiFriendAppChart",
  components: { ConfigForms, Chart },
  props: ["replaceFormItem", "defaultData", "fetch"],
  data() {
    return {
      params: {
        appId: 14,
        sumDate: moment().format("YYYY-MM-DD"),
        ...(this.defaultData || {}),
      },
      grids: [],
      chartDataProfit: {},
      chartDataAmount: {},
      chartDataMessage: {},
      chartDataUser: {},
      chartDataUSDT: {},
    };
  },
  computed: {
    formItems() {
      return [
        this.replaceFormItem || {
          type: "select",
          label: "App",
          key: "appId",
          contentWidth: "200px",
          options: appOptions,
        },
        {
          type: "date",
          label: "时间",
          key: "sumDate",
          contentWidth: "200px",
        },
      ];
    },
    // 走势图配置
    options() {
      return {
        graphList: [],
        responsive: true,
        maintainAspectRatio: false,
        // 图表标题
        title: {
          display: false,
        },
        // style: {
        //   strokewidth: 120
        // },
        hover: {
          mode: "nearest",
          intersect: true,
        },

        // 图例设置
        legend: {
          display: true,
          labels: {
            padding: 30,
            // // 使用圆形样式
            // usePointStyle: true
          },
          // 显示位置
          position: "top",
        },
        scales: {
          x: {
            display: true,
            scaleLabel: {
              display: true,
              labelString: "Month",
            },
          },
          y: {
            display: true,
            scaleLabel: {
              display: true,
              labelString: "Month",
            },
          },
          yAxes: [
            {
              scale: true,
              ticks: {
                beginAtZero: true,
                // callback: function(value) { if (value < 10 && value % 1 === 0) { return value } }
              },
            },
          ],
        },
        // tooltip提示样式
        tooltips: {
          position: "nearest",
          mode: "index",
          intersect: false,
          yPadding: 10,
          xPadding: 10,
          caretSize: 8,
          backgroundColor: "rgba(64, 87, 170, 1)",
          titleFontColor: "#fff",
          bodyFontColor: "#fff",
          borderColor: "#409eff",
          borderWidth: 4,
          enabled: true,
          // 同时显示x轴上的数据
          // 这里鼠标移到对应点上会同时显示english和math的成绩

          // 通过回调修改tooltips的标题
          callbacks: {
            // eslint-disable-next-line space-before-function-paren
            title: function(item) {
              return "" + item[0].xLabel + "";
            },
          },
        },
      };
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    updateParams(ps) {
      this.params = ps;
      this.refresh();
    },
    async refresh() {
      try {
        if (Object.values(this.params).filter((v) => !!v).length < 2) return;
        const r = await (this.fetch || aiFriendManageApi.getAppRealtimeImage)(
          this.params
        );
        this.assemblyStatInfo(r.data.appInfo);
        this.assemblyChartData(r.data);
      } catch (error) {
        console.error(error);
      }
    },
    // 对话、用户、消息
    assemblyStatInfo(info) {
      const grids = [
        { label: "提示词成本USDT", value: info.promptCost },
        { label: "提示词Token数", value: info.promptTokens },
        { label: "提示词消耗USDT", value: info.promptUsdt },
        { label: "提示词消耗积分", value: info.promptAmount },

        { label: "完成词成本USDT", value: info.completionCost },
        { label: "完成词Token数", value: info.completionTokens },
        { label: "完成词消耗USDT", value: info.completionUsdt },
        { label: "完成词消耗积分", value: info.completionAmount },

        { label: "总成本USDT", value: info.totalCost },
        { label: "总Token数", value: info.totalTokens },
        { label: "总消耗USDT", value: info.totalUsdt },
        { label: "总消耗积分", value: info.amount },

        { label: "创建对话数", value: info.createDialogs },
        { label: "总消息数", value: info.messages },
        { label: "总用户数", value: info.totalUser },
        { label: "盈利$", value: info.profitUsdt },
      ];
      this.grids = grids;
    },
    // 合并今天和昨天的数据
    mergeTodayAndYesterdayGraph(todayGraphList, yesterdayGraphList) {
      const mergedData = {};
      if (todayGraphList) {
        todayGraphList.forEach((item) => {
          const key = this.getTimeKey(item.statTime);
          mergedData[key] = { todayItem: item };
        });
      }
      console.log(JSON.parse(JSON.stringify(mergedData)));

      if (yesterdayGraphList) {
        yesterdayGraphList.forEach((item) => {
          const key = this.getTimeKey(item.statTime);

          mergedData[key]
            ? (mergedData[key].yesterdayItem = item)
            : (mergedData[key] = { yesterdayItem: item });
        });
      }
      const keys = Object.keys(mergedData).sort(
        (x, y) => moment(x, "HH:mm").valueOf() - moment(y, "HH:mm").valueOf()
      );
      return keys.map((key) => ({
        key,
        ...mergedData[key],
      }));
    },
    getTimeKey(time) {
      return moment(time)
        .utcOffset(480)
        .format("HH:mm");
    },
    assemblyChartData(data) {
      const todayGraphList = data.todayGraphList || [];
      const yesterdayGraphList = data.yesterdayGraphList || [];
      const mergedData = this.mergeTodayAndYesterdayGraph(
        todayGraphList,
        yesterdayGraphList
      );
      const labels = mergedData.map((item) => item.key);
      const getDataWithKey = (key, isToday = true, fixed = 6) => {
        return mergedData.map((item) =>
          isToday
            ? item.todayItem
              ? item.todayItem[key].toFixed(fixed)
              : 0
            : item.yesterdayItem
            ? item.yesterdayItem[key].toFixed(fixed)
            : 0
        );
      };
      this.chartDataProfit = {
        labels,
        datasets: [
          this.createDataset(
            "今天盈利USDT",
            getDataWithKey("profitUsdt"),
            chartLineColors[0]
          ),
          this.createDataset(
            "昨天盈利USDT",
            getDataWithKey("profitUsdt", false),
            lastChartLineColors[0]
          ),
        ],
      };
      this.chartDataAmount = {
        labels,
        datasets: [
          this.createDataset(
            "今天总消耗积分",
            getDataWithKey("amount"),
            chartLineColors[1]
          ),
          this.createDataset(
            "昨天总消耗积分",
            getDataWithKey("amount", false),
            lastChartLineColors[1]
          ),
        ],
      };
      this.chartDataUSDT = {
        labels,
        datasets: [
          this.createDataset(
            "今天总消耗USDT",
            getDataWithKey("totalUsdt"),
            chartLineColors[0]
          ),
          this.createDataset(
            "今天总成本USDT",
            getDataWithKey("totalCost"),
            chartLineColors[1]
          ),
          this.createDataset(
            "昨天总消耗USDT",
            getDataWithKey("totalUsdt", false),
            lastChartLineColors[0],
            true
          ),
          this.createDataset(
            "昨天总成本USDT",
            getDataWithKey("totalCost", false),
            lastChartLineColors[1],
            true
          ),
        ],
      };
      this.chartDataMessage = {
        labels,
        datasets: [
          this.createDataset(
            "今天消息数",
            getDataWithKey("messages", true, 0),
            chartLineColors[2]
          ),
          this.createDataset(
            "昨天天消息数",
            getDataWithKey("messages", false, 0),
            lastChartLineColors[2]
          ),
        ],
      };
      this.chartDataUser = {
        labels,
        datasets: [
          this.createDataset(
            "今天会话数",
            getDataWithKey("createDialogs", true, 0),
            chartLineColors[2]
          ),
          this.createDataset(
            "今天用户数",
            getDataWithKey("totalUser", true, 0),
            chartLineColors[0]
          ),
          this.createDataset(
            "昨天会话数",
            getDataWithKey("createDialogs", false, 0),
            lastChartLineColors[2],
            true
          ),
          this.createDataset(
            "昨天用户数",
            getDataWithKey("totalUser", false, 0),
            lastChartLineColors[0],
            true
          ),
        ],
      };
    },
    createDataset(label, data, borderColor, hidden = false) {
      return {
        label,
        data,
        hidden, // 是否默认选择
        fill: false,
        borderColor,
        // 取消填充后，只有图例中会显示相应背景色
        backgroundColor: "rgba(243,15,15,0.1)",
        lineTension: 0.32,
        borderWidth: 1.8,
        spanGaps: true,
        // 取消填充
        pointRadius: 0,
        pointHoverRadius: 1,
      };
    },
  },
  filters: {
    formatNumber(num) {
      return isInteger(num) ? num : num.toFixed(6);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-chart {
  .pick-summary {
    display: flex;
    align-items: flex-start;
    overflow: auto;
    margin-bottom: 20px;

    .pick-box {
      display: inline-block;
      padding: 30px 40px;
      background-color: #0001;
      border-radius: 10px;
      outline: none;
      border-radius: 15px;
      transition: 600ms ease all;
      border: none;
      outline: none;
      position: relative;

      /deep/ {
        .el-form-item {
          margin-bottom: 5px;

          &__label {
            font-size: 13px;
          }
        }
        .el-select {
          width: 100%;
        }
        .el-input {
          width: 100%;
          &--small {
            font-size: 12px;
          }
        }
      }
    }

    .pick-btns {
      display: flex;
      justify-content: center;
    }
  }

  .summary-box {
    flex: 1;
    min-width: 500px;
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;

    .summary-item {
      min-width: 150px;
      width: 100%;
      height: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #0001;
      color: #666;
      border-radius: 5px;
      font-size: 14px;

      &.even {
        background-color: #f001;
      }

      &.last-line {
        background-color: #00f1;
      }

      .val {
        font-size: 16px;
        color: #333;
        font-weight: bold;
      }
    }
  }
}
</style>
